import { inject, Injectable, signal } from '@angular/core';
import { ReCaptchaV3Service } from 'ng-recaptcha';

@Injectable({
    providedIn: 'root'
})
export class RecaptchaService {
    recaptchaV3Service = inject(ReCaptchaV3Service);

    currentV2Token = signal<string>(null);
    currentV3Token = signal<string>(null);

    withCaptchaV3(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.recaptchaV3Service.execute('withCaptchaV3').subscribe({
                next: (token) => {
                    this.currentV3Token.set(token);
                    resolve();
                },
                error: (error) => {
                    this.currentV3Token.set(null);
                    reject();
                }
            });
        });
    }
}
